import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FaceIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 15.7305C11.866 15.7305 15 12.5965 15 8.73053C15 4.86454 11.866 1.73053 8 1.73053C4.13401 1.73053 1 4.86454 1 8.73053C1 12.5965 4.13401 15.7305 8 15.7305ZM5.67098 9.39504C5.48574 9.02456 5.03524 8.87439 4.66475 9.05963C4.29427 9.24487 4.1441 9.69538 4.32934 10.0659C4.59331 10.5938 5.65516 11.9804 8.00016 11.9804C10.3452 11.9804 11.407 10.5938 11.671 10.0659C11.8562 9.69538 11.7061 9.24487 11.3356 9.05963C10.9651 8.87439 10.5146 9.02456 10.3293 9.39504C10.26 9.53378 9.65516 10.4804 8.00016 10.4804C6.34516 10.4804 5.74035 9.53378 5.67098 9.39504ZM5 6.73053C5 6.17825 5.44772 5.73053 6 5.73053C6.55228 5.73053 7 6.17825 7 6.73053V7.23053C7 7.50667 6.77614 7.73053 6.5 7.73053H5.5C5.22386 7.73053 5 7.50667 5 7.23053V6.73053ZM10 5.73053C9.44771 5.73053 9 6.17825 9 6.73053V7.23053C9 7.50667 9.22386 7.73053 9.5 7.73053H10.5C10.7761 7.73053 11 7.50667 11 7.23053V6.73053C11 6.17825 10.5523 5.73053 10 5.73053Z"
		/>
	</svg>
))
